import { z } from "zod";
import {
  BookingSchema,
  EventSchema,
  InvitationSchema,
  UserSchema,
} from "../models";

// Invitation with detail schema
export const InvitationWithDetailSchema = InvitationSchema.extend({
  booking: BookingSchema.extend({
    event: EventSchema,
    user: UserSchema,
  }),
  invitee: UserSchema.optional(),
});
export type InvitationWithDetail = z.infer<typeof InvitationWithDetailSchema>;

// Create friend invitation request schema
export const CreateInvitationRequestSchema = InvitationSchema.omit({
  id: true,
  inviteeId: true,
  expiresAt: true,
  status: true,
  respondedAt: true,
  createdAt: true,
  updatedAt: true,
});
export type CreateInvitationRequest = z.infer<
  typeof CreateInvitationRequestSchema
>;

// Confirm friend invitation request schema
export const ConfirmFriendInvitationRequestSchema = z.object({
  invitationId: z.string().min(6).max(20),
});
export type ConfirmFriendInvitationRequest = z.infer<
  typeof ConfirmFriendInvitationRequestSchema
>;
